import {ChangeDetectionStrategy, Component, OnDestroy} from '@angular/core';
import {AgRendererComponent} from 'ag-grid-angular';

@Component({ standalone: false,
    selector: 'irb-trade-details-symbol-cell',
    template: `  <span style='line-height:unset'
            class="nav-link-text" calltoaction [calltoactionPosition]="'right'"
            [calltoactionTemplate]="tradeDetailsSymbolToolTipTemplateRef"
            [calltoactionUsesHover]="true" [innerHTML]="displayData"></span>
    <ng-template #tradeDetailsSymbolToolTipTemplateRef >
        <div [innerHTML]="tooltipData">
            
        </div>
    </ng-template>`,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TradeDetailsSymbolRendererComponent implements AgRendererComponent, OnDestroy {
    params: any;
    displayData: string;
    tooltipData: string;

    constructor() {
    }

    agInit(params: any) {
        this.params = params;
        if (this.params.data) {
            
            this.formatSymb(params);
        }
    }

    ngOnDestroy(): void {
    }

    refresh(): boolean {
        return false;
    }
    formatSymb(params:any) {
        const inData = params.value;
        const item = params.data;
        const securityDesc = item.securityDescription;
        const isSwapExchange = item.isSwapExchange;
        let tooltipData = ((securityDesc && securityDesc != "") ? (inData + "<br />" + securityDesc) : inData);
        const isRollTrade = item.isRollTrade;
        const isOption = item.securityType === "Option";
    
        if (isSwapExchange) {
            const swapExchangeSymbol = item.swapExchangeSymbol;
            this.tooltipData = tooltipData;
            this.displayData = inData + ' to ' + swapExchangeSymbol;
         } else if (isRollTrade) {
            const swapExchangeSymbol = item.swapExchangeSymbol;
            const swapExchangeDescription = item.swapExchangeDescription;
            tooltipData = (securityDesc && securityDesc != "") ? securityDesc : "";
            tooltipData += "<br/>" + ((swapExchangeDescription && swapExchangeDescription != "") ? swapExchangeDescription : "");
            this.tooltipData = tooltipData;
            this.displayData = inData + ' <br/> ' + swapExchangeSymbol;
        } else if (isOption) {
            this.tooltipData = inData;
            this.displayData = inData;
        } else { 
            this.tooltipData = tooltipData;
            this.displayData = inData;
        }
    }
}
